import React from "react";
import { ArrowRight, Shield, Clock, Award } from "lucide-react";

const CTASection = ({ onOpenForm }) => {
  return (
    <section className="section-padding bg-gradient-to-br from-[#1e3a8a] via-[#1e40af] to-[#3b82f6] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#d4af37] rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom px-4 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Main Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Protect Your Brand Today
          </h2>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Don't wait until it's too late. Secure your trademark registration now and safeguard your 
            business's most valuable asset.
          </p>

          <p className="text-lg text-white/80 mb-12 max-w-3xl mx-auto leading-relaxed">
            Every day without trademark protection puts your brand at risk. Competitors could file for similar 
            marks, copycats could confuse your customers, and you could lose the exclusive rights to your own 
            business name. Take action now and ensure your brand receives the legal protection it deserves.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <button
              onClick={onOpenForm}
              className="bg-[#d4af37] text-[#1e3a8a] px-10 py-5 rounded-lg font-bold text-lg hover:bg-[#f59e0b] transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center space-x-2"
            >
              <span>Register My Trademark</span>
              <ArrowRight className="w-6 h-6" />
            </button>
            
            <button onClick={onOpenForm} className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg font-bold text-lg hover:bg-white/20 transition-all duration-300 border border-white/30 flex items-center justify-center space-x-2">
              <span>Get Free Consultation</span>
            </button>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <Shield className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold mb-3">Guaranteed Protection</h3>
              <p className="text-white/80 leading-relaxed">
                Comprehensive trademark registration with ongoing monitoring and legal support
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <Clock className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold mb-3">Fast Processing</h3>
              <p className="text-white/80 leading-relaxed">
                Quick turnaround times with expedited filing options available for urgent needs
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <Award className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold mb-3">Expert Attorneys</h3>
              <p className="text-white/80 leading-relaxed">
                USPTO-registered trademark attorneys with decades of combined experience
              </p>
            </div>
          </div>

          {/* Urgency Message */}
          <div className="mt-16 bg-white/5 backdrop-blur-sm p-8 rounded-2xl border-l-4 border-[#d4af37]">
            <p className="text-2xl font-bold text-[#d4af37] mb-3">
              🔥 Limited Time Offer
            </p>
            <p className="text-lg text-white/90 leading-relaxed">
              Register your trademark this month and receive a FREE comprehensive trademark search report 
              (valued at $299) plus priority processing. Don't miss out on this exclusive opportunity to 
              protect your brand at an unbeatable value.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
